import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { CardsVideoCall } from './CardsVideoCall';
import { InfoVideoCall } from './InfoVideoCall';

import styles from './styles.module.scss';

export const VideoCallContainer = memo(() => {
  const { t } = useTranslation('welcome');

  return (
    <div className={styles.video_call_container}>
      <div className={styles.video_call_top}>
        <div className={styles.video_call_title_container}>
          <p>{t('Video_call_title_')}</p>
          <span>{t('Video_call_title_part2_')}</span>
        </div>
        <p className={styles.video_call_description}>{t('Video_call_li_2_')}</p>
      </div>
      <CardsVideoCall />
      <InfoVideoCall />
    </div>
  );
});
